module.exports = __webpack_public_path__ + "assets/img/budapark1-640.c9afe257.webp";